module.exports = __webpack_public_path__ + "static/media/heavy_pound52.50828604.jpg";